<template lang="pug">
#app
  router-view
  vue-progress-bar
</template>

<script>
export default {
  name: 'app',
}
</script>



// WEBPACK FOOTER //
// App.vue?39476370